import axios from 'axios'

//import { isProduction, env } from '@/utils/env'

//var httpOk = null ;

class APICommercialisti {

  getUrlDomain(nome_metodo) {

    let result = "";

    if (location.hostname == "localhost") {
      result = location.protocol + "//emtool.local/";
    }

    if (location.hostname != "localhost") {

      result = location.protocol + "//" + location.hostname + "/";

    }

    return result + nome_metodo;


  }

  // async saveCommercialista(commercialista, user, id) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("val_id", id);

  //   for (var key in commercialista) {
  //     formData.append(key, commercialista[key]);
  //   }

  //   return axios.post(this.getUrlDomain("EmtAgilaSaveCommApi"), formData, { 'Content-Type': 'multipart/form-data' });

  // }

  async saveCommercialista(commercialista, user, id) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);

    for (var key in commercialista) {
      formData.append(key, commercialista[key]);
    }

    return axios.post(this.getUrlDomain("goSaveCommercialistaAgila"), formData, { 'Content-Type': 'multipart/form-data' });

  }


  // async editCommercialista(id, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("id", id);


  //   return axios.post(this.getUrlDomain("EmtAgilaEditCommApi"), formData, { 'Content-Type': 'multipart/form-data' });

  // }

  async editCommercialista(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("id", id);


    return axios.post(this.getUrlDomain("goEditCommercialistaAgila"), formData, { 'Content-Type': 'multipart/form-data' });

  }

  // async deleteCommercialista(id, user) {

  //   let formData = new FormData();

  //   formData.append("username", user);
  //   formData.append("val_id", id);


  //   return axios.post(this.getUrlDomain("EmtAgilaDeleteCommApi"), formData, { 'Content-Type': 'multipart/form-data' });

  // }

  async deleteCommercialista(id, user) {

    let formData = new FormData();

    formData.append("username", user);
    formData.append("val_id", id);


    return axios.post(this.getUrlDomain("goDeleteCommercialistaAgila"), formData, { 'Content-Type': 'multipart/form-data' });

  }

}

export default new APICommercialisti({
  url: "https://services.ebadge.it/public/api/"
})
